import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-heading font-black text-primary-500 tracking-tight">
              黑料社区
            </Link>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              明星八卦、网红爆料、娱乐圈内幕，第一时间掌握圈内最劲爆资讯。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/star-gossip" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">分类浏览</Link>
              <Link to="/about" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/star-gossip" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">明星八卦</Link>
              <Link to="/category/influencer-expose" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">网红曝光</Link>
              <Link to="/category/industry-insider" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">娱乐圈内幕</Link>
              <Link to="/category/hot-trending" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">热议话题</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2">
              <a href="mailto:tips@heiliaoshequ.com" className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">
                <i className="ri-mail-line mr-2"></i>tips@heiliaoshequ.com
              </a>
              <p className="text-sm text-foreground-500 whitespace-nowrap">
                <i className="ri-shield-check-line mr-2"></i>匿名爆料，严格保密
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; 2026 黑料社区 - 版权所有。本站内容仅供娱乐参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}